import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { baseUrl } from "../../BaseUrl";
import DashboardLayout from "../../Shared/DashboardLayout";


const VehicleAdd = () => {
  const navigate = useNavigate();
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });
  const [errorMessage, setErrorMessage] = useState('')
  const [vehicleForm, setVehicleForm] = useState({
    vehicle_name: '',
    vehicle_type: '',
    registration_no: '',
  });

  // handle change function
  const handleChange = (e) => {
    const { name, value } = e.target;
    setVehicleForm({
      ...vehicleForm,
      [name]: value,
    });

  };

  // handle submit function...
    const handleSubmit = async (e) => {
    e.preventDefault() 
    try {
        const jwtToken = localStorage.getItem('access');
        const response = await axios.post(
        `${baseUrl}/sales/api/vehicle/`,
        vehicleForm,
        {
            headers: {
            Authorization: `JWT ${jwtToken}`,
            },
        }
        );
        console.log(response);
        navigate('/vehicle-list');
        Toast.fire({
        icon: 'success',
        title: 'Successfully Add',
        });
    } catch (error) {
      if(error.response.data.vehicle_name){
        Toast.fire({
          icon: 'error',
          title: `Vehicle name already exists`,
          });
          setErrorMessage('Vehicle name already exist')
      }else if(error.response.data.registration_no){
        Toast.fire({
          icon: 'error',
          title: `Registration no already exist`,
          });
          setErrorMessage('Registration no already exist')
      }
      else{
        Toast.fire({
          icon: 'error',
          title: `Ops! ${error.message}`,
          });
          console.log(error);
      }
    }
    };

  return (
    <DashboardLayout>
    <div className="p-5">
      <div className="flex">
        <div className="bg-white p-8 rounded shadow-xl">
          <h1 className="uppercase font-semibold text-xl mb-3">Vehicle Add Form</h1>
          <hr />

          <form onSubmit={handleSubmit}>
            <div className="w-full max-w-lg mt-2">
              <div className="md:flex md:items-center mb-4">
                <div className="w-[200px]">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-2" htmlFor="inline-full-name">
                  Vehicle Name*
                  </label>
                </div>
                <div className="w-full mx-1">
                  <input
                    type="text"
                    name="vehicle_name"
                    id="vehicle_name"
                    value={vehicleForm.vehicle_name}
                    onChange={handleChange}
                    className="block w-full rounded-md border-0 pl-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Vehicle name"
                    required
                  />
                  {errorMessage && (
                    <span className="text-red-600">Vehicle name already exist</span>
                  )}
                </div>
              </div>
            </div>

            <div className="w-full max-w-lg">
              <div className="md:flex md:items-center mb-2">
                <div className="w-[200px]">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-5" htmlFor="inline-full-name">
                  Vehicle Type*
                  </label>
                </div>
                <div className="w-[100%]">
                  <input
                    type="text"
                    value={vehicleForm.vehicle_type}
                    name="vehicle_type"
                    id="vehicle_type"
                    onChange={handleChange}
                    className="block w-full rounded-md border-0 pl-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Vehicle type"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="w-full max-w-lg">
              <div className="md:flex md:items-center mb-2">
                <div className="w-[200px]">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-5" htmlFor="inline-full-name">
                  Registration Number*
                  </label>
                </div>
                <div className="w-[100%]">
                  <input
                    type="text"
                    value={vehicleForm.registration_no}
                    name="registration_no"
                    id="registration_no"
                    onChange={handleChange}
                    className="block w-full rounded-md border-0 pl-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Enter vin.."
                    required
                  />
                  {errorMessage && (
                    <span className="text-red-600">Registration no already exist</span>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-5">
              <button
                type="submit"
                className="w-[150px] bg-sky-500 border text-white font-medium rounded-lg h-10"
              >
                Submit
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
    </DashboardLayout>
  );
};

export default VehicleAdd;
